import * as React from "react";
import { Flex, Link, Text } from "@chakra-ui/react";

export const Footer = () => {
  const year = new Date().getFullYear();

  interface FooterLinkProps {
    href: string;
    children: React.ReactNode;
  }

  const FooterLink = ({ href, children }: FooterLinkProps) => (
    <Link textTransform="uppercase" fontWeight="bold" fontSize="sm" href={href}>
      {children}
    </Link>
  );

  return (
    <Flex alignItems="center" flexDir="column" py={6}>
      <Flex gap={4} mb={2}>
        <FooterLink href="https://www.rxgames.com">rxgames.com</FooterLink>
        <FooterLink href="https://www.rxgames.com/contact">Support</FooterLink>
      </Flex>
      <Text fontSize="sm" color="gray.500">
        RxGames &copy; {year}. All rights reserved.
      </Text>
      <Text fontSize="xs" textAlign="center" color="gray.400">
        v1.0.0
      </Text>
    </Flex>
  );
};
